import { useTranslation } from 'react-i18next';
import Handler from '../../../../Handler';
import { FormInput } from '../../../../components/form/FormInput';
import { useLabel } from '../../../../hooks/useLabel';
import { projectFormValidations } from '../form';

export const ManagerInfo = (props) => {
  const { register, errors } = props;
  const { t, i18n } = useTranslation();
  const { PLACEHOLDER } = useLabel();
  const isEn = i18n.language === 'en';
  const validations = projectFormValidations(isEn);

  return (
    <article className='flex flex-col gap-4 w-[945px] mb-4 py-8'>
      <header>
        <h2>{t('APPLICANT')}</h2>
      </header>
      <div className='grid grid-cols-2 gap-4'>
        <FormInput
          label={t('CONTACT_NAME')}
          required
          placeholder={PLACEHOLDER.NAME}
          error={errors.name}
          {...register('name', {
            required: validations.name.required,
            validate: validations.name.validate,
          })}
        />
        <FormInput
          label={t('MOBILE')}
          required
          placeholder={PLACEHOLDER.PHONE}
          error={errors.phone}
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
            maxLength: 11,
            ...Handler.numericInputHandlers,
          }}
          {...register('phone', {
            required: validations.phone.required,
            validate: validations.phone.validate,
          })}
        />
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <FormInput
          label={t('DEPARTMENT')}
          placeholder={PLACEHOLDER.DEPARTMENT}
          error={errors.department}
          {...register('department')}
        />
        <FormInput
          label={t('EMAIL')}
          required
          placeholder={PLACEHOLDER.EMAIL}
          error={errors.email}
          {...register('email', {
            required: validations.email.required,
            validate: validations.email.validate,
          })}
        />
      </div>
    </article>
  );
};
